import React from 'react'
import pt from 'prop-types'
import { CSSTransition } from 'react-transition-group'

import './Fade.scss'

const Fade = ({ classname, time, onEnter, onExited, children, onExit, onEntered, mounted, style }) => (
  <div className={'fade ' + (classname || '')} style={style}>
    <CSSTransition
      in={mounted}
      appear
      unmountOnExit
      className={'fade--transition ' + (classname ? classname + '--transition' : '')}
      classNames={'fade'}
      timeout={{
        enter: time,
        exit: time
      }}
      onExit={onExit}
      onExited={onExited}
      onEnter={onEnter}
      onEntered={onEntered}
      style={{ transition: `opacity ${time}ms ease-in-out` }}
    >
      <div className="fade-initial">{children}</div>
    </CSSTransition>
  </div>
)

Fade.propTypes = {
  classname: pt.string,
  mounted: pt.bool,
  time: pt.number,
  children: pt.object,
  onEnter: pt.func,
  onEntered: pt.func,
  onExit: pt.func,
  onExited: pt.func,
  style: pt.object
}

export default Fade
